import oss from "ali-oss";
import { v4 } from "uuid";

class Uploader {
    serverBase: string = "http://lanshifs.oss-cn-beijing.aliyuncs.com/"
    upload(file,name?:string) {
        let client = new oss({
            region: "oss-cn-beijing",
            //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
            accessKeyId: "LTAIFm1PqyHbFIFV",
            accessKeySecret: "zL9QWeKdgPZ8nS3nfL7DrFWJeUa2Xl",
            bucket: "lanshifs"
        });
        // let file:File = req.file
        let dotIndex = file.name.lastIndexOf('.')
        let d = 'asfas'
        name = 'essaydr/attachment/' + file.name.substr(0,dotIndex) + '-' + v4() + '.'+ (file.name.split('.').pop())
        return new Promise<any>((resolve, reject) => {
            client
                .put(name, file)
                .then(res => {
                    resolve(res)
                    // resolve(this.serverBase + name)
                })
                .catch(e => {
                    
                    reject()
                    console.log(e);
                });
        })
    }
}

export default new Uploader()